var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("p", { staticClass: "tracking-wider" }, [
    _c(
      "small",
      { staticClass: "mention" },
      [
        _vm.project.partner
          ? [
              _vm._v("\n            Made in peace with\n            "),
              _vm.project.partner.link
                ? _c(
                    "a",
                    {
                      style: { color: _vm.project.colors["text-secondary"] },
                      attrs: {
                        rel: "nofollow",
                        target: "_blank",
                        href: _vm.project.partner.link,
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.project.partner.title) +
                          "\n            "
                      ),
                    ]
                  )
                : _c(
                    "span",
                    { style: { color: _vm.project.colors["text-secondary"] } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.project.partner.title) +
                          "\n            "
                      ),
                    ]
                  ),
              _vm._v("\n            ✌️\n        "),
            ]
          : [
              _vm._v(" Crafted carefuly by "),
              _c("span", [_vm._v("Us")]),
              _vm._v(" ❤️"),
            ],
      ],
      2
    ),
    _vm._v(" "),
    _vm.project.type === "partner" && _vm.project.associate !== null
      ? _c("small", { staticClass: "mention" }, [
          _vm._v("\n        Made in alliance with\n        "),
          _vm.project.associate.link
            ? _c(
                "a",
                {
                  style: { color: _vm.project.colors["text-secondary"] },
                  attrs: {
                    rel: "nofollow",
                    target: "_blank",
                    href: _vm.project.associate.link,
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.project.associate.title) +
                      "\n        "
                  ),
                ]
              )
            : _c(
                "span",
                { style: { color: _vm.project.colors["text-secondary"] } },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.project.associate.title) +
                      "\n        "
                  ),
                ]
              ),
          _vm._v("\n        🤝\n    "),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.project.link
      ? _c("a", { attrs: { href: _vm.project.link, target: "_blank" } }, [
          _vm._v("\n        Have a look\n    "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }